import { Reducer } from 'redux';
// import _ from 'lodash';

import { Action, ActionType } from '../actionTypes/zoneActionTypes';
import { IZone as Zone } from '../../models/zone';

export interface IZoneState {
    zones: Zone[];
    loading: boolean;
    error: string | null,
}
const initialState = {
    zones: [],
    loading: false,
    error: null,   
};
export const ZoneReducer: Reducer<IZoneState, Action> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case ActionType.FETCH_ZONES_SUCCESS:
            return {
                ...state,
                zones: action.payload.data,
                loading: false
            };

        default:
            return state;
    }
};
